/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Empty_CellInputs */

const en_statement_taxonomy_editor_empty_cell = /** @type {(inputs: Statement_Taxonomy_Editor_Empty_CellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Empty)`)
};

const nl_statement_taxonomy_editor_empty_cell = /** @type {(inputs: Statement_Taxonomy_Editor_Empty_CellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Leeg)`)
};

/**
* | output |
* | --- |
* | "(Empty)" |
*
* @param {Statement_Taxonomy_Editor_Empty_CellInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_empty_cell = /** @type {((inputs?: Statement_Taxonomy_Editor_Empty_CellInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Empty_CellInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_empty_cell(inputs)
	return en_statement_taxonomy_editor_empty_cell(inputs)
});